import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { type MerchantUsersTableEnum, proxyNewUser } from '../../../../../shared/proxies/newUserProxy'
import { executeDetermineUserLists } from '../../../../../shared/apiUtils/executeDetermineUserLists'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { GlobalSortDirectionEnum, oppositeSortDirection } from '../../../../../shared/types/GlobalSortDirectionEnum'

interface TableHeaderProps {
  title: string
  sortColumn: MerchantUsersTableEnum
  width: number
}

export function MerchantUsersTableHeader ({ title, sortColumn, width }: TableHeaderProps): ReactElement {
  const newUsersProxySnap = useSnapshot(proxyNewUser)
  const sortDirection = newUsersProxySnap.filters.sortDirection
  const isActive = newUsersProxySnap.filters.sortColumn === sortColumn
  const { siteTheme: { tableHeaderColors } } = useSnapshot(proxyGlobalAuth)
  const onClick = (): void => {
    proxyNewUser.filters.sortColumn = sortColumn
    proxyNewUser.filters.sortDirection = oppositeSortDirection(sortDirection)
    void executeDetermineUserLists({ displayLoader: false })
  }

  return (
    <th
      className={cn(tableHeaderColors.backgroundClasses, 'py-2 px-4 cursor-pointer')}
      style={{ width: `${width}%` }}
      onClick={onClick}
    >
      <div className="flex">
        <div className={tableHeaderColors.secondaryFontClasses}>{title}</div>
        <div
          className={cn(tableHeaderColors.fontClasses, 'flex flex-col ml-2 justify-center items-center')}
          style={{ fontSize: '0.55rem' }}
        >
          <span
            className={
              cn(
                isActive && sortDirection === GlobalSortDirectionEnum.Ascending && tableHeaderColors.secondaryFontClasses
              )
            }
          >
            ▲
          </span>
          <span
            className={
              cn(
                isActive && sortDirection === GlobalSortDirectionEnum.Descending && tableHeaderColors.secondaryFontClasses
              )
            }
          >
            ▼
          </span>
        </div>
      </div>
    </th>
  )
}
